import React, { useContext } from 'react';
import Spinner from '../../components/spinner/spinner';
import { useParams } from 'react-router-dom';
import { useLoader } from '../../api/useLoader';
import { MenuItemsUHA } from '../../pagelayout/menuitems';
import translations from './practiceplaceprofile.i18n';
import { useIntl } from 'react-intl';
import {
  HttpError,
  PraksisstedInfoPutDto,
} from '../../api/generated/studiested-generated-api';
import PracticePlaceProfileUha from './practiceplaceprofile.uha';
import { StudiestedApiContext } from '../../api/StudiestedApiContext';
import {
  AlpNotificationType,
  NotificationFunctionContext,
} from '../../components/notifications/notificationProvider';
import { uuidv4 } from '../../util/uuidv4';

const PracticePlaceProfilePage: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { id } = useParams<{ id: string }>();
  const { praksisstedApi } = useContext(StudiestedApiContext);
  const { addNotification } = useContext(NotificationFunctionContext);
  const { formatMessage } = useIntl();

  const { data, loading, reload } = useLoader(
    async () =>
      praksisstedApi.praksisstedprofilIdGet({ pathParams: { id: id || '' } }),
    [id],
    true,
    true,
  );

  if (loading) return <Spinner />;
  if (!data || !id) return <></>;

  const saveProfile = (beskrivelse: string, krav: string) => {
    praksisstedApi
      .praksisstedprofilIdPut({
        pathParams: { id },
        praksisstedprofilPutDto: { beskrivelse: beskrivelse, krav: krav },
      })
      .then(() => {
        addNotification({
          id: uuidv4(),
          type: AlpNotificationType.SUCCESS,
          message: formatMessage({ id: translations.lagret.id }),
        });
        reload();
      })
      .catch((err: HttpError) =>
        addNotification({
          id: uuidv4(),
          type: AlpNotificationType.ERROR,
          message: err.body,
        }),
      );
  };

  const saveContactInfo = (updatedPraksissted: PraksisstedInfoPutDto) => {
    praksisstedApi
      .praksisstedprofilIdInfoPut({
        pathParams: { id },
        praksisstedInfoPutDto: updatedPraksissted,
      })
      .then(() => {
        addNotification({
          id: uuidv4(),
          type: AlpNotificationType.SUCCESS,
          message: formatMessage({ id: translations.lagret.id }),
        });
        reload();
      })
      .catch((err: HttpError) =>
        addNotification({
          id: uuidv4(),
          type: AlpNotificationType.ERROR,
          message: err.body,
        }),
      );
  };

  return (
    <PracticePlaceProfileUha
      data={data}
      menuItems={<MenuItemsUHA />}
      canEdit={data.kanRedigere}
      isAdmin={data.erAdmin}
      saveHandler={saveProfile}
      saveContactInfo={saveContactInfo}
    />
  );
};

export default PracticePlaceProfilePage;
